import { Notification } from '../../types/notification';
import { NOTIFICATION_CATEGORIES, NOTIFICATION_REQUEST_TYPES } from './constants';

/**
 * 사용자 타입
 */
export type UserType = 'teacher' | 'user';

/**
 * 알림 카테고리에 따른 네비게이션 경로 반환 (선생님용)
 * @param notification 알림 객체
 * @returns 이동할 경로 또는 null
 */
const getTeacherNavigationPath = (notification: Notification): string | null => {
  const { category, metadata } = notification;

  switch (category) {
    case NOTIFICATION_CATEGORIES.LESSON_REQUEST:
      return '/admin/lesson-requests';

    case NOTIFICATION_CATEGORIES.ONEDAY_REQUEST:
      return '/admin/oneday-requests';

    case NOTIFICATION_CATEGORIES.MODIFICATION_REQUEST:
      // metadata에서 requestType 확인
      if (metadata?.requestType === NOTIFICATION_REQUEST_TYPES.CANCEL_LESSON) {
        return '/admin/lesson-cancellations';
      }
      return '/admin/lesson-modifications';

    default:
      return null;
  }
};

/**
 * 알림 카테고리에 따른 네비게이션 경로 반환 (사용자용)
 * @param notification 알림 객체
 * @returns 이동할 경로 또는 null
 */
const getUserNavigationPath = (notification: Notification): string | null => {
  const { category } = notification;

  switch (category) {
    case NOTIFICATION_CATEGORIES.PRACTICE_BOOKED:
      return '/user/practice-booking';

    case NOTIFICATION_CATEGORIES.MODIFICATION_APPROVED:
    case NOTIFICATION_CATEGORIES.MODIFICATION_REJECTED:
      return '/user/schedule';

    case NOTIFICATION_CATEGORIES.LESSON_REQUEST_APPROVED:
    case NOTIFICATION_CATEGORIES.LESSON_REQUEST_REJECTED:
      return '/user/dashboard';

    case NOTIFICATION_CATEGORIES.PAYMENT_DUE:
      return '/user/dashboard';

    default:
      return null;
  }
};

/**
 * 알림에 따른 네비게이션 경로 반환
 * @param notification 알림 객체
 * @param userType 사용자 타입 ('teacher' | 'user')
 * @returns 이동할 경로 또는 null
 */
export const getNavigationPath = (
  notification: Notification,
  userType: UserType
): string | null => {
  if (userType === 'teacher') {
    return getTeacherNavigationPath(notification);
  }

  return getUserNavigationPath(notification);
};

/**
 * 알림에 네비게이션 경로가 있는지 확인
 * @param notification 알림 객체
 * @param userType 사용자 타입
 * @returns 네비게이션 가능 여부
 */
export const hasNavigationPath = (
  notification: Notification,
  userType: UserType
): boolean => {
  return getNavigationPath(notification, userType) !== null;
};
